module.exports = __webpack_public_path__ + "static/img/__1585.6d9b7b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__1585.jpg
// module id = NguO
// module chunks = 0